export function fullName(name) {
  if (typeof name === 'string') {
    return name.trim() || 'N/A';
  }
  if (!name) {
    return 'N/A';
  }
  const { firstName, middleName, lastName } = name;
  const fullNameStr = [firstName, middleName, lastName]
    .filter(Boolean)
    .join(' ')
    .trim();

  return fullNameStr || 'N/A';
}
